import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import TouchstoneAssets from '@touchstone/touchstone-assets';
import App from './App.vue';
import router from './router';
import Common from './components';

import './assets/css/app.css';
import './services/filters';

Sentry.init({
    Vue,
    environment: process.env.NODE_ENV,
    dsn: process.env.VUE_APP_SENTRY_DNS
});

Vue.config.productionTip = false;
Vue.use(TouchstoneAssets);
Vue.use(Common);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
